import { Component, OnInit, inject, signal } from '@angular/core';
import { ApiClientService } from '../../core/api/api-client.service';
import { CourseSummary } from '../../core/models/portal.models';

@Component({
  selector: 'app-courses-page',
  standalone: true,
  templateUrl: './courses-page.component.html'
})
export class CoursesPageComponent implements OnInit {
  private readonly api = inject(ApiClientService);
  protected readonly courses = signal<CourseSummary[]>([]);

  ngOnInit(): void {
    this.api.courses().subscribe((courses) => this.courses.set(courses));
  }
}
